import Immutable from 'immutable'

export function stateGetIn(
    state,
    reducerName,
    arr,
    moduleName,
    defaultValue
) {
    if (
        state &&
        state[reducerName] &&
        (
            state[reducerName] instanceof Immutable.Map ||
            state[reducerName] instanceof Immutable.List ||
            state[reducerName] instanceof Immutable.Set ||
            state[reducerName] instanceof Immutable.OrderedMap ||
            state[reducerName] instanceof Immutable.OrderedSet
        )
    ) {

        return state[reducerName].getIn(arr, defaultValue)

    } else {
        // if (__DEV__) console.error(`${reducerName} is not Immutable at ${moduleName}`)

        return null
    }
}

export function stateGetInToJS(
    state,
    reducerName,
    arr,
    moduleName,
    defaultValue
) {
    let immutableObj = stateGetIn(state, reducerName, arr, moduleName, defaultValue)

    if (
        null !== immutableObj &&
        'undefined' !== typeof immutableObj
    ) {
        return (
                immutableObj instanceof Immutable.Map ||
                immutableObj instanceof Immutable.List ||
                immutableObj instanceof Immutable.Set ||
                immutableObj instanceof Immutable.OrderedMap ||
                immutableObj instanceof Immutable.OrderedSet
            )
                ? immutableObj.toJS()
                : immutableObj

    } else {
        return defaultValue ? defaultValue : null
    }
}

// export function stateGet(
//     state,
//     reducerName,
//     val,
//     moduleName,
//     defaultValue
// ) {
//     if (
//         state &&
//         state[reducerName] &&
//         (
//             state[reducerName] instanceof Immutable.Map ||
//             state[reducerName] instanceof Immutable.List ||
//             state[reducerName] instanceof Immutable.Set ||
//             state[reducerName] instanceof Immutable.OrderedMap ||
//             state[reducerName] instanceof Immutable.OrderedSet
//         )
//     ) {
//
//         return state[reducerName].get(val, defaultValue)
//
//     } else {
//
//         // if (__DEV__) console.error(`${reducerName} is not Immutable at ${moduleName}`)
//
//         return null
//     }
// }



// WEBPACK FOOTER //
// ./src/lib/immutableHelpers.js